import { Controller } from 'stimulus';

window.initializeDatePickers = function(elements) {
  if ($(elements).length) {
    var daterangeOptions = {
      drops: 'auto',
      locale: {
        format: 'MM-DD-YYYY'
      },
      'alwaysShowCalendars': true,
      autoApply: true,
      singleDatePicker: true,
    }

    if ($(elements).data('min-date') !== undefined){
      daterangeOptions = {
        ...daterangeOptions,
        minDate: moment($(elements).data('min-date'))
      }
    }

    $(elements).daterangepicker(daterangeOptions)

    $(elements).on('apply.daterangepicker', function(e, picker) {
      $(this).addClass('is-selected').closest('.daterange__holder').addClass('active');
    });
  }
}

export default class extends Controller {
  connect() {
    this.initializeDatePickers();
  }

  initializeDatePickers() {
    $('.daterangefull').each(function() {
      const showTime = $(this).data('show-time') !== undefined;

      if (this.value && this.value.match(/\d{4}-\d{2}-\d{2}/)) {
        this.value = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }).format(Date.parse(this.value)).replaceAll("/","-");
      }

      $(this).daterangepicker({
        autoUpdateInput: false,
        drops: 'auto',
        autoApply: true,
        singleDatePicker: true,
        timePicker: showTime,
        timePicker24Hour: false,
        timePickerSeconds: false,
        locale: {
          format: showTime ? 'MM-DD-YYYY hh:mm A' : 'MM-DD-YYYY',
          cancelLabel: 'Clear'
        }
      });
    });

    $('.daterangefull').on('apply.daterangepicker', function(e, picker) {
      $(this).addClass('is-selected').closest('.daterange__holder').addClass('active');
      $(this).val(picker.startDate.format($(this).data('show-time') !== undefined ? 'MM-DD-YYYY hh:mm A' : 'MM-DD-YYYY'))
    });

    $('#appModal').on('shown.bs.modal', function(event) {
      initializeDatePickers($(event.target).find('.daterangefull'))
    });
  }
}
